import { makeStyles } from "@material-ui/styles";

const styles = makeStyles((theme) => ({
    logoouter: {
		width: 170,
		width: 170,
		margin: "auto",
		marginTop: -50,
		transition:".3s",
		[theme.breakpoints.down("lg")]:{
			width: 140,
			marginLeft: 20,
			marginTop: -30,
		},
		[theme.breakpoints.down("md")]: {
			width: 130,
			left: "calc(50% - 65px)",
			bottom: -60,
		},
		[theme.breakpoints.down("sm")]:{
			width: "auto",
			marginLeft:0,
			marginTop:-20,
		}
	}
}));
export default styles;
